/* ==========================================================================
   VP WISHLIST
   Stores wishlisted product handles in localStorage under 'vp_wishlist'.
   Any element with [data-vp-wishlist-toggle][data-handle] becomes a toggle.
   Dispatches 'vp:wishlist:change' on document whenever the list changes.
   ========================================================================== */
(function () {
  var STORAGE_KEY = 'vp_wishlist';

  function getWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('vp:wishlist:change', { detail: { list: list } }));
    updateCountBadges(list.length);
  }

  function isWishlisted(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggleWishlist(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    return list.indexOf(handle) !== -1;
  }

  function removeFromWishlist(handle) {
    var list = getWishlist().filter(function (h) { return h !== handle; });
    saveWishlist(list);
  }

  function updateCountBadges(count) {
    document.querySelectorAll('[data-vp-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshButtonStates() {
    var list = getWishlist();
    document.querySelectorAll('[data-vp-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      var active = list.indexOf(handle) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vp-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-handle');
    var active = toggleWishlist(handle);
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  });

  document.addEventListener('DOMContentLoaded', function () {
    refreshButtonStates();
    updateCountBadges(getWishlist().length);
  });

  document.addEventListener('vp:wishlist:change', refreshButtonStates);

  window.vpWishlist = {
    get: getWishlist,
    has: isWishlisted,
    toggle: toggleWishlist,
    remove: removeFromWishlist
  };
})();
